/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTimecardTransactionsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {GetTimecardTransactionsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getTimecardTransactions = (request: GetTimecardTransactionsRequest, options?: CashRequestOptions) => post<GetTimecardTransactionsRequest, GetTimecardTransactionsResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetTimecardTransactions", request, {...options, rejectOnError: true })